import { Server } from "lucide-react";
import type { ModuleManifest } from "@/modules/module-registry";
import type { PermissionDefinition } from "@/modules/access";

// What the Datacenter app lets staff grant. `datacenter-app`: read: open the app. `datacenter`: read: see the sites and what they hold; write: create and edit; admin: delete. `datacenter-secrets`: write: add or replace a stored login secret; read: reveal one (audited).
const datacenterPermissions: readonly PermissionDefinition[] = [
  { resource: "datacenter-app", label: "datacenter-app.resource", levels: ["read"], ownable: false, staffOnly: true },
  { resource: "datacenter", label: "datacenter.resource", levels: ["read", "write", "admin"], ownable: false, staffOnly: true },
  { resource: "datacenter-secrets", label: "datacenter-secrets.resource", levels: ["read", "write"], ownable: false, staffOnly: true },
];

/** The Datacenter app declares itself: an optional app, off for new installs until an administrator switches it on in the App store. It keeps the sites, devices and addresses of the network. */
export const datacenterManifest: ModuleManifest = {
  id: "datacenter", href: "/datacenter", icon: Server,
  name: "auth.modules.datacenter", description: "settings.appStore.apps.datacenter.description",
  permissionDefinitions: datacenterPermissions,
  permissions: ["datacenter-app", "datacenter", "datacenter-secrets"], appPermission: "datacenter-app", needs: [], contributes: [{ slot: "contacts.customer-file.smart-button", id: "datacenter", order: 30, permission: { resource: "datacenter-app", level: "read" } }],
  optional: true,
};
